import type { ProductCardPrices } from "@shared/graphql.types";
import { useEffect, useState } from "react";

type UserType = "member" | "guest" | undefined;

export const useStrikethrough = (prices?: ProductCardPrices) => {
  const [activeUserType, setActiveUserTypeValue] = useState<UserType>(
    prices?.activeType
  );
  const setActiveUserType = (type: UserType) => {
    setActiveUserTypeValue(type);
  };

  useEffect(() => {
    setActiveUserType(prices?.activeType);
  }, [prices?.activeType]);

  if (!prices) {
    return {
      hasPromoPrice: false as const,
      promoPrice: null,
      price: null,
      setActiveUserType
    };
  }

  const price = activeUserType === "member" ? prices.member : prices.guest;
  const hasPromo = !!price.promo;

  return {
    hasPromoPrice: hasPromo,
    promoPrice: hasPromo ? price.promo : null,
    price: price.regular,
    setActiveUserType
  };
};
